
import { AlertOctagon, ShieldAlert, Shield, ShieldCheck } from 'lucide-react';

// Get severity icon based on severity level
export const getSeverityIcon = (severity: string) => {
  switch (severity.toLowerCase()) {
    case 'critical':
    case 'krytyczna':
      return <AlertOctagon className="h-5 w-5 text-red-700" />;
    case 'high':
    case 'wysoka':
      return <ShieldAlert className="h-5 w-5 text-amber-800" />;
    case 'medium':
    case 'średnia':
      return <Shield className="h-5 w-5 text-amber-500" />;
    case 'low':
    case 'niska':
      return <ShieldCheck className="h-5 w-5 text-emerald-500" />;
    default:
      return <Shield className="h-5 w-5" />;
  }
};

// Format severity name for display
export const getSeverityClass = (severity: string) => {
  switch (severity.toLowerCase()) {
    case 'critical':
    case 'krytyczna':
      return "text-red-700";
    case 'high':
    case 'wysoka':
      return "text-amber-800";
    case 'medium':
    case 'średnia':
      return "text-amber-500";
    case 'low':
    case 'niska':
      return "text-emerald-500";
    default:
      return "text-primary";
  }
};
